import * as $ from 'jquery';
import { AuthTokensInfo, createAuthTokensInfo } from "../../accounts/models/AccountTypes";
import { createUserRolesInfo, UserRolesModel } from "../../accounts/models/UserRolesInfo";
import { Utils } from './Utils';

export class Authentication {
    public static setupAjaxAuthorization() {
        const userAuth = this.getUserAuth();

        if (userAuth) {
            let unknownUserId = this.getUnknownUserId();

            if (Utils.isNullOrEmpty(unknownUserId)) {
                unknownUserId = crypto.randomUUID();
                this.setUnknownUserId(unknownUserId);
            }

            $.ajaxSetup({
                cache: false,
                headers: {
                    "Authorization": "Bearer " + userAuth.accessToken.token,
                    "WarehouseId": this.getSelectedWarehouseId().toString(),
                    "UnknownUserId": unknownUserId
                }
            });
        }
    }

    /////////////// LastLogin //////////////////////////
    private static lastLoginRequestKey = "lastloginrequest";

    public static setLastLoginRequest() {
        localStorage.setItem(this.lastLoginRequestKey, Date.now().toString());
    }

    public static getLastLoginRequest() {
        const value = localStorage.getItem(this.lastLoginRequestKey);

        return !value ? 0 : parseFloat(value);
    }

    //////////////// Warehouse //////////////////////////
    private static selectedWarehouseKey = "selectedWarehouse";

    public static setWarehouse(warehouseId: number) {
        localStorage.setItem(this.selectedWarehouseKey, warehouseId.toString());
    }

    public static getSelectedWarehouseId() {
        const selectedId = localStorage.getItem(this.selectedWarehouseKey);
        return selectedId ? parseInt(selectedId) : 0;
    }

    //////////////////// User Auth ////////////////////////
    private static userAuthKey = "auth_tokens";

    public static setUserAuth(account: AuthTokensInfo) {
        localStorage.setItem(this.userAuthKey, JSON.stringify(account));
        this.setupAjaxAuthorization();
    }

    public static getUserAuth(): AuthTokensInfo {
        const value = localStorage.getItem(this.userAuthKey);

        return !value ? undefined : JSON.parse(value);
    }

    public static getUserRoles(): UserRolesModel {
        var auth = this.getUserAuth();

        if (auth) {
            return auth.userRoles;
        }

        return createUserRolesInfo();
    }

    public static clearUserAuth() {
        const account = createAuthTokensInfo();
        this.setUserAuth(account);
    }

    public static isLoggedIn(): boolean {
        var auth = this.getUserAuth();

        if (auth) {
            return !Utils.isNullOrEmpty(auth.accessToken.token);
        }

        return false;
    }

    public static isAdmin(): boolean {
        const userRoles = this.getUserRoles();

        if (userRoles) return userRoles.isAdministrator;

        return false;
    }

    public static isGM(): boolean {
        const userRoles = this.getUserRoles();

        if (userRoles) return userRoles.isGeneralManager;

        return false;
    }

    public static isSupervisor(): boolean {
        const userRoles = this.getUserRoles();

        if (userRoles) return userRoles.isSalesSupervisor;

        return false;
    }

    //////////////// Unknown User Id //////////////////////////
    private static unknownUserIdKey = "unknown_user_id";

    public static setUnknownUserId(userId: string) {
        localStorage.setItem(this.unknownUserIdKey, userId);
    }

    public static getUnknownUserId() {
        return localStorage.getItem(this.unknownUserIdKey) ?? undefined;
    }

    //////////////// Country Code //////////////////////////
    private static countryCodeName = "countryCode";

    public static setCountryCode(countryCode: string) {
        localStorage.setItem(this.countryCodeName, countryCode);
    }

    public static getCountryCode() {
        return localStorage.getItem(this.countryCodeName);
    }

    //////////////// Phone No //////////////////////////
    private static phoneNoName = "phoneNo";

    public static setPhoneNo(phoneNo: string) {
        localStorage.setItem(this.phoneNoName, phoneNo);
    }

    public static getPhoneNo() {
        return localStorage.getItem(this.phoneNoName);
    }

    //////////////// Email //////////////////////////
    private static emailName = "email";

    public static setEmail(email: string) {
        localStorage.setItem(this.emailName, email);
    }

    public static getEmail() {
        return localStorage.getItem(this.emailName) ?? undefined;
    }

    //////////////// Customer ID //////////////////////////
    private static customerIdName = "customer_id";

    public static setCustomer(customerId: number) {
        localStorage.setItem(this.customerIdName, customerId.toString());
    }

    public static getCustomer() {
        return localStorage.getItem(this.customerIdName) ?? "0";
    }

    public static clearCustomer() {
    }
}